<script setup lang="ts">
import type { ButtonProps } from '~/components/Button.vue'

const props = withDefaults(
  defineProps<ButtonProps>(),
  {
    size: 'medium',
    variant: 'primary',
  },
)
</script>

<template>
  <Button v-bind="props" color="blurple" class="!bg-blurple-100 hover:!bg-blurple-300">
    Bruk
  </Button>
</template>
